package fr.frux.core.designsystem.layout

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag

/**
 * Écran d'entrée scindé en grand écran (spec §6) : un panneau de marque à gauche, le contenu
 * borné et centré à droite. En compact, seul le contenu est composé, à l'identique d'aujourd'hui.
 *
 * Le visuel arrive par slot plutôt que par un composant fixe : le logo de marque vit dans
 * composeApp, au-dessus de feature-auth, qui ne peut pas en dépendre.
 */
@Composable
fun SplitEntryLayout(
    visual: @Composable BoxScope.() -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    when (LocalFruxLayoutMode.current) {
        FruxLayoutMode.Compact -> {
            Box(modifier) { content() }
        }

        FruxLayoutMode.Expanded -> {
            Row(modifier.fillMaxSize()) {
                Box(
                    modifier =
                        Modifier
                            .weight(FruxLayoutDefaults.ENTRY_VISUAL_FRACTION)
                            .fillMaxHeight()
                            .background(MaterialTheme.colorScheme.primaryContainer)
                            .testTag("split_entry_visual"),
                    contentAlignment = Alignment.Center,
                    content = visual,
                )
                // Fond opaque sur toute la moitié droite, pas seulement sous le contenu borné :
                // les écrans d'entrée sont composés au-dessus de la carte persistante (ADR 0009),
                // qui transparaissait dans les marges de la colonne (#415).
                Box(
                    modifier =
                        Modifier
                            .weight(1f - FruxLayoutDefaults.ENTRY_VISUAL_FRACTION)
                            .fillMaxHeight()
                            .background(MaterialTheme.colorScheme.background),
                    contentAlignment = Alignment.Center,
                ) {
                    Box(
                        modifier =
                            Modifier
                                .widthIn(max = FruxLayoutDefaults.EntryContentMaxWidth)
                                .fillMaxHeight()
                                .testTag("split_entry_content"),
                    ) {
                        content()
                    }
                }
            }
        }
    }
}
